import React, { useEffect, useState } from 'react';

import { WEBVIEW } from '@constants/serviceConstants';
import { sendNativeMessageAPI } from '@lib/native';
import { sendAiMessage } from '@lib/ai';
import { aiAgent } from '@api/axiosAPI';

const AiAgentTemplate = () => {
  const [aiAgentSrno, setAiAgentSrno] = useState(null); // AI에이전트일련번호
  const [aiAgentFeedCd, setAiAgentFeedCd] = useState(null);
  const [aiAgentFeedDtlSrno, setAiAgentFeedDtlSrno] = useState(null);
  const [hiraMdctSrno, setHiraMdctSrno] = useState(null);
  const [healthReport, setHealthReport] = useState(null); // 건강리포트 파라미터

  // AI 에이전트 조언 프롬프트 템플릿 조회
  const { refetch: fetchAiFeedPrptTmpt } = aiAgent.getAiAgentFeedPrptTmpt(
    ['getAiAgentFeedPrptTmpt'],
    {
      enabled: false,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: (res) => {
        onSuccessAiAgentFeedPrptTmpt(res);
      },
    },
    { aiAgentSrno, aiAgentFeedCd, aiAgentFeedDtlSrno, hiraMdctSrno }
  );

  // AI 에이전트 조언 프롬프트 템플릿 조회 for 건강리포트
  const { refetch: fetchAiFeedPrptTmptForReport } = aiAgent.getAiAgentFeedPrptTmptForReport(
    ['getAiAgentFeedPrptTmptForReport'],
    {
      enabled: false,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: (res) => {
        onSuccessAiAgentFeedPrptTmptForReport(res);
      },
    },
    healthReport
  );

  // AI 에이전트 수정
  const putAiAgentFeed = aiAgent.putAiAgentFeed({
    onSuccess: () => {
      sendNativeMessageAPI(WEBVIEW.SEND_CODE.AI_CHAT, { resultCode: 200 });
      setAiAgentSrno(null);
    },
  });

  // AI 에이전트 조언 수정 for 건강리포트
  const putAiAgentFeedForReport = aiAgent.putAiAgentFeedForReport({
    onSuccess: () => {
      sendNativeMessageAPI(WEBVIEW.SEND_CODE.AI_CHAT, { resultCode: 200 });
      setHealthReport(null);
    },
  });

  // AI 에이전트 조언 요청
  const getAiAdvice = (args) => {
    if (args.aiAgentSrno) {
      const { aiAgentSrno, aiAgentFeedCd, aiAgentFeedDtlSrno, hiraMdctSrno } = args;

      setHiraMdctSrno(hiraMdctSrno);
      setAiAgentFeedDtlSrno(aiAgentFeedDtlSrno);
      setAiAgentFeedCd(aiAgentFeedCd);
      setAiAgentSrno(aiAgentSrno);
    } else if (args.repoAnalPerd) {
      // 건강 리포트 AI 조언 요청
      const { repoAnalPerd, cldrPrdDivCd, msmtItmCd } = args;
      setHealthReport({ repoAnalPerd, cldrPrdDivCd, msmtItmCd });
    }
  };

  // AI 에이전트 조언 요청
  const onSuccessAiAgentFeedPrptTmpt = async (dataList) => {
    try {
      const returnData = _.cloneDeep(dataList);

      let index = 0;
      for await (let data of dataList) {
        const result = await sendAiMessage(data.prptTmpt);

        returnData[index].aiAgentFeedCtt = result.content;
        index++;
      }

      putAiAgentFeed.mutate(returnData);
    } catch (err) {
      sendNativeMessageAPI(WEBVIEW.SEND_CODE.AI_CHAT, { resultCode: 500, resultData: err });
    }
  };

  // AI 에이전트 조언 업데이트 for 건강리포트
  const onSuccessAiAgentFeedPrptTmptForReport = async (data) => {
    try {
      const result = await sendAiMessage(data.prptTmpt);
      putAiAgentFeedForReport.mutate({ ...healthReport, aiAgentFeedCtt: result.content });
    } catch (err) {
      sendNativeMessageAPI(WEBVIEW.SEND_CODE.AI_CHAT, { resultCode: 500, resultData: err });
    }
  };

  useEffect(() => {
    if (!_.isNull(aiAgentSrno)) {
      fetchAiFeedPrptTmpt();
    } else if (!_.isNull(healthReport)) {
      fetchAiFeedPrptTmptForReport();
    }
  }, [aiAgentSrno, healthReport]);

  window.getAiAdvice = getAiAdvice;

  return <div>webview area!</div>;
};

export default AiAgentTemplate;
